import styled from 'styled-components';
import device from '../../../../components/mediaQueries';

const SocialWrapper = styled.div`
  align-items: center;
  display: flex;

  ${device.mobile`
  justify-content: center;
  height: 50px;
`}

  ${device.desktop`
  width: 125px;
`}
`;

export default SocialWrapper;
